import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TaskComponent } from './components/task/task.component';
import { TaskListComponent } from './components/task-list/task-list.component';
import { MonitoringMatrixComponent } from './components/monitoring-matrix/monitoring-matrix.component';


const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'create-task/:taskId'
    },
    {
        path: 'create-task/:taskId',
        component: TaskComponent
    },
    {
        path: 'task',
        component: TaskComponent
    },
    {
        path: 'monitoring-matrix',
        component: MonitoringMatrixComponent
    },
    {
        path: 'task-list',
        component: TaskListComponent
    },
   
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [RouterModule],
})
export class TaskRoutingModule { }
